export default __webpack_public_path__ + "static/media/image-menu-bar.c00804fd.png";